import layout from './HeaderView.html?raw';
import View from '@/Views/View';
import ComponentManager from '@/Management/ComponentManager';
import Messenger from '@/Utility/Messenger';
import HeaderViewModel from '@/ViewModels/Views/HeaderViewModel';

export default class HeaderView extends View {
    protected view: JQuery<HTMLElement>;

    public constructor(protected readonly viewModel: HeaderViewModel, protected readonly element?: JQuery<HTMLElement>, protected readonly customLayout?: string) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, this.customLayout != null ? this.customLayout : layout);

        const $body = $('body');

        this.addEventHandler('click', $body, (event) => {
            if (!ko.isObservable(this.viewModel.menuVisible))
                return;

            const target = $(event.target);
            const isVisible = this.viewModel.menuVisible();
            const inOverlay = target.closest('.menu-overlay').length > 0;
            const inBody = target.closest('body').length > 0;

            if (isVisible && inBody && !inOverlay) {
                this.viewModel.menuVisible(false);
            }
        });

        this.addEventHandler('click', $body, (event) => {
            if (!ko.isObservable(this.viewModel.favoritesVisible))
                return;

            const target = $(event.target);
            const isVisible = this.viewModel.favoritesVisible();
            const inOverlay = target.closest('.favorite-overlay').length > 0;
            const inBody = target.closest('body').length > 0;

            if (isVisible && inBody && !inOverlay) {
                this.viewModel.favoritesVisible(false);
            }
        });

        this.addEventHandler('click', $body, (event) => {
            if (!ko.isObservable(this.viewModel.tasksVisible))
                return;

            const target = $(event.target);
            const isVisible = this.viewModel.tasksVisible();
            const inOverlay = target.closest('.tasks-overlay').length > 0;
            const inBody = target.closest('body').length > 0;

            if (isVisible && inBody && !inOverlay) {
                this.viewModel.tasksVisible(false);
            }
        });

        this.addEventHandler('click', $body, (event) => {
            if (!ko.isObservable(this.viewModel.showUserMenu))
                return;

            const target = $(event.target);
            const isVisible = this.viewModel.showUserMenu();

            if (!isVisible) return;

            const inOverlay = target.closest('.userdropdownmenu-overlay').length > 0;
            const inCircle = target.closest('.user-circle-link').length > 0;
            const inChangeLanguage = target.closest('.change-lang').length > 0;
            const inDarkmodeMenu = target.closest('.darkmode-menu').length > 0;
            const inBody = target.closest('body').length > 0;


            if (inBody && inOverlay && !inChangeLanguage && !inDarkmodeMenu) {
                this.viewModel.showUserMenu(false);
                return;
            }

            if (!inOverlay && !inCircle) {
                this.viewModel.showUserMenu(false);
                return;
            }
        });

        Messenger.registerForMessageId('NavigationStartedMessage', (message) => {
            if (ko.isObservable(this.viewModel.menuVisible))
                this.viewModel.menuVisible(false);

            if(ko.isObservable(this.viewModel.favoritesVisible))
                this.viewModel.favoritesVisible(false);

            if(ko.isObservable(this.viewModel.tasksVisible))
                this.viewModel.tasksVisible(false);

            if (ko.isObservable(this.viewModel.showUserMenu))
                this.viewModel.showUserMenu(false);
        }, this);

        return this.view;
    }
}

ComponentManager.setView('HeaderView', HeaderView, 'RADPresentation.HTMLClient.DefaultViewExtensions');